

























import { Vue, Component, Emit, VModel, Prop } from 'vue-property-decorator';

import { SelectOption } from '../../../logic/types';
import { VueComponent } from "../../types/VueComponent";
import { tooltipTrigger } from "../../utils/tooltipTrigger";

@Component({
  methods: {
    tooltipTrigger
  }
})
export default class HttpRequestTypePopover extends Vue {
  @VModel() model!: string

  @Prop() options!: Array<SelectOption>

  @Emit()
  menuItemSelect(payload: {item: VueComponent, key:string, selectedKeys: Array<string>}) {
    return payload
  }
}
